import { render } from "./LocalizedLink.vue?vue&type=template&id=5013fc37"
import script from "./LocalizedLink.vue?vue&type=script&lang=js"
export * from "./LocalizedLink.vue?vue&type=script&lang=js"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__